import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useCountdown } from '../../../../../hooks/useCountdown';
import { useStores } from '../../../../../stores/useStores';
import { formatTime } from '../../../../../utils/time';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface UpcomingMissionWidgetTimerProps {
  extended?: boolean;
}

function UpcomingMissionWidgetTimerComponent(props: UpcomingMissionWidgetTimerProps) {
  const { extended } = props;
  const { t } = useTranslation();
  const { missionsStore } = useStores();
  const secondsLeft = useCountdown(missionsStore.upcomingMissionStartAt);
  if (secondsLeft === null) {
    return null;
  }
  const timer = formatTime(secondsLeft, 's', t);

  return <GeneralWidgetTimer extended={extended} timerValue={timer} />;
}

export const UpcomingMissionWidgetTimer = observer(UpcomingMissionWidgetTimerComponent);
